module.exports = __webpack_public_path__ + "images/tour/return.cd5d4dbf55bbb14bff7d.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/return.svg
// module id = /vrq
// module chunks = 1